import { axios } from '@/utils/request'


export function getArticleList(category, pageNo = 1, pageSize = 99) {
    return axios({
        url: "/teaching/teachingArticle/getArticleList",
        method: "get",
        params: {category, pageNo, pageSize}
    });
}

export function getArticleDetail(id) {
    return axios({
        url: "/teaching/teachingArticle/getArticle",
        method: "get",
        params: {id}
    });
}

export function getCmsList(cmsType, pageNo = 1, pageSize = 99) {
    return axios({
        url: "/teaching/teachingCms/getCmsList",
        method: "get",
        params: {cmsType, pageNo, pageSize}
    });
}